import React, { useState } from "react";
import { LoginUser } from "../../../utilities/servicesTrackWeb";
import useTrackWebContext from "../../../hooks/useTrackWebContext";

const LoginForm = () => {
  const { handleLogin, handleToken } = useTrackWebContext();
  const [profile, setProfile] = useState("comercio");
  const [numberOfShopOrBrand, setNumberOfShopOrBrand] = useState("");
  const [passwordUser, setPasswordUser] = useState("");
  const [noLoginAnswer, setNoLoginAnswer] = useState(false);

  const fetchData = async (e) => {
    e.preventDefault();
    const dataLogin = await LoginUser(
      numberOfShopOrBrand,
      passwordUser,
      profile
    );
    if (!dataLogin) return setNoLoginAnswer(true);
    const dataLoginSuccess = dataLogin?.success;
    handleLogin(dataLoginSuccess);
    handleToken(dataLogin?.User?.nro_comercio, dataLogin?.token);
    setNoLoginAnswer(false);
  };

  const placeholders = {
    marca: "N° de Marca",
    comercio: "N° de Comercio",
    colaborador: "Correo electrónico",
  };

  return (
    <>
      <form className="mx-8 md:mx-14 mt-4 md:mt-11 mb-4" onSubmit={fetchData}>
        <h2 className="text-red-500 text-sm mb-2">
          {noLoginAnswer ? "Nro de comercio o contraseña inválidos" : ""}
        </h2>

        {/* Select Perfil */}
        <div className="mb-4 flex items-center justify-between gap-3">
          <label className="font-body text-gray-900 font-bold text-2xl">
            Perfil
          </label>
          <select
            value={profile}
            onChange={(e) => setProfile(e.target.value)}
            className="w-32 py-2 rounded-full border border-gray-500 bg-white text-gray-700 font-body focus:bg-neutral-50 focus:border-clvblue"
          >
            <option value="marca">Marca</option>
            <option value="comercio">Comercio</option>
            <option value="colaborador">Colaborador</option>
          </select>
        </div>

        <input
          type="text"
          value={numberOfShopOrBrand}
          onChange={(e) => setNumberOfShopOrBrand(e.target.value)}
          className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-[#fff] placeholder-gray-500 font-normal placeholder-text-lg font-body focus:rounded-full  focus:bg-neutral-50 focus:border-clvblue"
          placeholder={placeholders[profile]} 
        />

        <input
          type="password"
          value={passwordUser}
          onChange={(e) => setPasswordUser(e.target.value)}
          className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-[#fff] placeholder-gray-500 font-normal placeholder-text-lg font-body focus:rounded-full  focus:bg-neutral-50 focus:border-clvblue"
          placeholder="Contraseña"
        />

        <div className="flex flex-col md:flex-row text-center md:justify-center items-center py-2">
          <button
            type="submit"
            className="w-full h-10 flex justify-center items-center px-4 py-1 bg-clvblue border-0 rounded-full text-gray-50 text-xl font-body font-bold hover:bg-[#C2CBDF] hover:border-2 hover:border-clvblue hover:text-clvblue"
          >
            Ingresar
          </button>
        </div>
      </form>
    </>
  );
};

export default LoginForm;